import React from 'react';

import { Box, BorderBox, ButtonPrimary } from '@primer/components'
import Card from './Card'


const containerStyle = {
  borderRadius: "6px",
  border: '1px solid #dedede',
}
const callToActionStyle = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 2
}


export default function(props) {
  return (
    <Box className="django-doctor-before-after" style={containerStyle}>
      <ButtonPrimary variant={'large'} onClick={props.onClick} style={callToActionStyle}>Show {props.countLeft} more</ButtonPrimary>
      <div style={{filter: 'blur(4px)'}}>
        <Card {...props.nextMessage} showLabels={false} />
      </div>
    </Box>
  )
}